'use client';

import BaseModal from '@c/modals/BaseModal';
import { prefix } from '@util/imagePrefix';
import { XIcon } from 'lucide-react';
import Image from 'next/image';
import AektivTradeInForm from './form/aektivTradeInForm';

type AektivTradeInModalProps = {
  dismiss: () => void;
  open: boolean;
};

export default function AektivTradeInModal({
  dismiss,
  open,
}: AektivTradeInModalProps) {
  return (
    <BaseModal isOpen={open} dismiss={dismiss} hideCloseIcon>
      <div className="flex w-full justify-between">
        <Image
          src={`${prefix}/assets/aektiv-modal-bg_1920x2560.png`}
          className="h-[72rem] w-full object-contain object-left"
          alt="Aektiv Trade-in Program"
          height={800}
          width={800}
        />

        <div className="-ml-[17rem] flex w-[70rem] flex-col gap-y-8 pr-[1rem] pt-[3rem]">
          <div className="flex flex-col gap-y-4">
            <div className="flex w-full items-center justify-between pr-[3rem]">
              <h1 className="text-[2.7rem] font-semibold text-black">
                Aektiv Trade-In Program
              </h1>

              <button type="button" aria-label="Close modal">
                <XIcon className="h-10 w-10 text-zinc-600" onClick={dismiss} />
              </button>
            </div>

            <p className="w-[46rem] text-[1.8rem] font-medium text-zinc-600">
              After submitting this form, a message thread with our trade in
              team will open and we will be in touch with you shortly.
            </p>
          </div>

          <AektivTradeInForm dismiss={dismiss} />
        </div>
      </div>
    </BaseModal>
  );
}
